import ReactGA from "react-ga4"

//const TRACKING_ID = "G-HDZTDX3ELH"

function init() {
  if(window._env_.GoogleAnalyticsKey){
    // Enable debug mode on the local development environment
    const isDev = !process.env.NODE_ENV || process.env.NODE_ENV === "development"
    ReactGA.initialize(window._env_.GoogleAnalyticsKey, { debug: isDev})
  }
}

function sendEvent(payload) {
  if(window._env_.GoogleAnalyticsKey){
    ReactGA.event(payload)
  }
}

function sendPageview(path) {
  if(window._env_.GoogleAnalyticsKey){
    ReactGA.set({ page: path })
    ReactGA.send(path)
  }
}

export default {
  init,
  sendEvent,
  sendPageview,
}